import { useEffect, useState } from 'react'
import Template0 from '../templates/Template0'
import { apiClient } from '../../../core/api_client'
import Table1 from '../tables/Table1'
import Table3 from '../tables/Table3'

const MenzilStats = ({ id }) => {
    const [data, setData] = useState()
    const [projectsData, setProjectsData] = useState()


    useEffect(() => {
        console.log("id in comp " + id)
        apiClient.get("/reports/" + id)
            .then(res => {
                // console.log("res ",res.data)
                setProjectsData(res.data)
                var temp = res.data
                temp.templates = JSON.parse(temp.templates)

                return temp.templates;
            })
            .then(data => {
                // console.log("data >>> ", data);
                setData(data.general)
                // setProjectsData(data.projects)
            }).catch(err => console.log(err))
    }, [id])

    return (
		<div className='py-5 px-2'>
            {(!data || !projectsData) ? (
                <div>Loading...</div>
            ) : (
                <>
                    <div className='temp1-stats my-4'>
                        {projectsData.total_cabinets &&
                            <div className="d-flex align-items-center justify-content-between">
                                <h5 className="block-bg4 text-white px-2 py-3 col-11">"Güzəştli mənzil" sistemində qeydiyyatdan keçərək elektron kabinetə sahib olan vətəndaşların sayı</h5>
                                <h5 className='bg-highlight text-center text-white p-3 col-1'>{projectsData.total_cabinets}</h5>
                            </div>
                        }
                        {projectsData.cabinets_participated &&
                            <div className="d-flex align-items-center justify-content-between">
                                <h5 className="block-bg4 text-white col-11 px-2 py-3">Satış zamanı mənzil seçimində iştirak edən istifadəçilərin sayı</h5>
                                <h5 className='bg-highlight text-center text-white py-3 px-4 col-1'>{projectsData.cabinets_participated}</h5>
                            </div>
                        }
                    </div>
                    {projectsData.templates?.projects?.length > 0 ? (
                        projectsData.templates.projects.map((proj, i) => (
                            console.warn("proj ", proj),
                            <Table1
                                key={proj.project_name ?? i}
                                data={proj.template0}
                                project={projectsData.notes.find(p => p.project_name === proj.projectName)}
                            />
                        ))
                    ) : (
                        <div>No project tables to display.</div>
                    )}
                    {projectsData.templates?.projects?.length > 0 ? (
                        projectsData.templates.projects.map((proj, i) => (
                            <Table3
                                key={proj.project_name ?? i}
                                data={proj.template0}
                                project={projectsData.notes.find(p => p.project_name === proj.projectName)}
                            />
                        ))
                    ) : (
                        <div>No project tables to display.</div>
                    )}
                </>
            )}
        </div>
    )
}

export default MenzilStats 
